/* GoGo Solar — mobile menu for the homepage.

   The ported React header hides its nav links below 768px and offers
   nothing in their place, so on a phone the homepage had no menu at all:
   just the wordmark and Get a quote. Every other page has the theme's
   drawer. This adds the missing one.

   Two departures from the React link list:
     - Gallery is dropped. That section was replaced by the reviews block,
       so #gallery has been an anchor to nothing for a while.
     - Projects is dropped, to match the theme drawer on the inner pages.
   Technology and Light Hire are added in their place.

   The button is injected into React's <nav> and re-injected on every
   observer pass, because React rewrites that subtree. The panel itself
   lives on <body>, out of React's reach, and is positioned under the
   header at open time — the same approach bsl-nav.js uses for the desktop
   dropdown.

   Note: the button needs flex-direction:column. It is a flex container so
   the bars centre, and without the explicit column the three bars lay out
   side by side instead of stacking. */
(function () {
  var STYLE_ID = "bsl-homenav-style-v2";
  var BTN_ID = "bsl-homenav-btn";
  var PANEL_ID = "bsl-homenav-panel";
  var GOLD = "#F5A800";
  var INK = "#171A15";
  var MAXW = 767;

  var ITEMS = [
    { label: "The range", href: "#range" },
    { label: "For homes", href: "#homes" },
    { label: "Fields & farms", href: "#farms" },
    { label: "For business", href: "#business" },
    { sep: true },
    { label: "Solar Lights", href: "/collections/solar-lights" },
    { label: "CCTV", href: "/collections/cctv" },
    { label: "Solar Fans", href: "/collections/solar-fans" },
    { label: "Shop all", href: "/collections/all" },
    { sep: true },
    { label: "Light Hire", href: "/pages/light-hire" },
    { label: "Technology", href: "/pages/technology" },
    { label: "About", href: "/pages/about-us" },
    { label: "Contact", href: "/pages/contact" }
  ];

  function styles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement("style");
    s.id = STYLE_ID;
    s.textContent = [
      "#" + BTN_ID + "{display:none;flex-direction:column;align-items:center;" +
        "justify-content:center;width:40px;height:40px;margin-right:.4rem;" +
        "background:none;border:0;padding:0;cursor:pointer;color:" + INK + ";" +
        "flex:0 0 auto;-webkit-tap-highlight-color:transparent}",
      "#" + BTN_ID + " span{display:block;width:20px;height:2px;background:currentColor;" +
        "border-radius:2px;transition:transform .22s ease,opacity .18s ease}",
      "#" + BTN_ID + " span + span{margin-top:5px}",
      "#" + BTN_ID + "[aria-expanded='true'] span:nth-child(1){transform:translateY(7px) rotate(45deg)}",
      "#" + BTN_ID + "[aria-expanded='true'] span:nth-child(2){opacity:0}",
      "#" + BTN_ID + "[aria-expanded='true'] span:nth-child(3){transform:translateY(-7px) rotate(-45deg)}",
      "@media(max-width:" + MAXW + "px){#" + BTN_ID + "{display:flex}}",

      "#" + PANEL_ID + "{position:fixed;left:0;right:0;z-index:9998;background:#fff;" +
        "border-bottom:1px solid rgba(23,26,21,.10);" +
        "box-shadow:0 24px 50px rgba(23,26,21,.16);" +
        "font-family:Inter,system-ui,sans-serif;padding:.5rem 0 1rem;" +
        "max-height:calc(100vh - 110px);overflow-y:auto;" +
        "opacity:0;visibility:hidden;transform:translateY(-8px);" +
        "transition:opacity .2s ease,transform .2s ease,visibility .2s}",
      "#" + PANEL_ID + ".open{opacity:1;visibility:visible;transform:translateY(0)}",
      "#" + PANEL_ID + " a{display:block;padding:.85rem 1.5rem;text-decoration:none;" +
        "color:" + INK + ";font-size:1rem;font-weight:600;line-height:1.3}",
      "#" + PANEL_ID + " a:active{background:#EEF0EB}",
      "#" + PANEL_ID + " hr{border:0;border-top:1px solid rgba(23,26,21,.10);margin:.5rem 1.5rem}",
      "#" + PANEL_ID + " .bsl-hn-cta{margin:.6rem 1.5rem 0;background:" + GOLD + ";" +
        "color:" + INK + ";border-radius:999px;text-align:center;font-weight:800;" +
        "letter-spacing:.06em;text-transform:uppercase;font-size:.82rem;padding:.95rem 1rem}",
      "#bsl-homenav-scrim{position:fixed;inset:0;z-index:9997;background:rgba(23,26,21,.35);" +
        "opacity:0;visibility:hidden;transition:opacity .2s ease,visibility .2s}",
      "#bsl-homenav-scrim.open{opacity:1;visibility:visible}",
      "@media(min-width:" + (MAXW + 1) + "px){#" + PANEL_ID + ",#bsl-homenav-scrim{display:none}}"
    ].join("");
    document.head.appendChild(s);
  }

  function panel() {
    var p = document.getElementById(PANEL_ID);
    if (p) return p;

    var scrim = document.createElement("div");
    scrim.id = "bsl-homenav-scrim";
    scrim.addEventListener("click", close);
    document.body.appendChild(scrim);

    p = document.createElement("div");
    p.id = PANEL_ID;
    p.setAttribute("role", "menu");
    p.innerHTML =
      ITEMS.map(function (i) {
        if (i.sep) return "<hr>";
        return '<a role="menuitem" href="' + i.href + '">' + i.label + "</a>";
      }).join("") +
      '<a class="bsl-hn-cta" href="#quote">Get a quote</a>';

    p.addEventListener("click", function (e) {
      if (e.target.tagName === "A") close();
    });
    document.body.appendChild(p);
    return p;
  }

  function isOpen() {
    var p = document.getElementById(PANEL_ID);
    return !!(p && p.classList.contains("open"));
  }

  function position() {
    var p = document.getElementById(PANEL_ID);
    var h = document.querySelector("header");
    if (!p || !h) return;
    p.style.top = Math.round(h.getBoundingClientRect().bottom) + "px";
  }

  function open() {
    styles();
    var p = panel();
    position();
    p.classList.add("open");
    var sc = document.getElementById("bsl-homenav-scrim");
    if (sc) sc.classList.add("open");
    var b = document.getElementById(BTN_ID);
    if (b) b.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }

  function close() {
    var p = document.getElementById(PANEL_ID);
    if (p) p.classList.remove("open");
    var sc = document.getElementById("bsl-homenav-scrim");
    if (sc) sc.classList.remove("open");
    var b = document.getElementById(BTN_ID);
    if (b) b.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  function button() {
    var nav = document.querySelector("header nav");
    if (!nav) return;

    var existing = document.getElementById(BTN_ID);
    if (existing && existing.parentElement === nav && nav.firstElementChild === existing) return;
    if (existing) existing.remove();

    var b = document.createElement("button");
    b.id = BTN_ID;
    b.type = "button";
    b.setAttribute("aria-label", "Menu");
    b.setAttribute("aria-expanded", "false");
    b.innerHTML = "<span></span><span></span><span></span>";
    b.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen()) close(); else open();
    });
    nav.insertBefore(b, nav.firstChild);
  }

  function run() {
    styles();
    button();
    if (isOpen()) position();
  }

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  window.addEventListener("resize", function () {
    if (window.innerWidth > MAXW) close();
    else if (isOpen()) position();
  });
  window.addEventListener("scroll", function () { if (isOpen()) position(); }, { passive: true });

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") run();
  else document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);
})();
